import { render, staticRenderFns } from "./takeaway_location_modal.vue?vue&type=template&id=63dfcaca&scoped=true&"
import script from "./takeaway_location_modal.vue?vue&type=script&lang=js&"
export * from "./takeaway_location_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dfcaca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63dfcaca')) {
      api.createRecord('63dfcaca', component.options)
    } else {
      api.reload('63dfcaca', component.options)
    }
    module.hot.accept("./takeaway_location_modal.vue?vue&type=template&id=63dfcaca&scoped=true&", function () {
      api.rerender('63dfcaca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/takeaway/location/takeaway_location_modal.vue"
export default component.exports